<%--
@Project Name: 赛橙表
@Author: liu.yang
@Date: 2019-09-26 10:23
@Email: 849941112@qq.com
@Idea: WebStorm
--%>

<template>
    <div class="layout">
        <div class="siderbar-wrapper" :style="{width: this.isCollapsed?'64px':'200px'}">
            <div class="logo-wrapper">
                <!--<span>赛橙表</span>-->
                <img src="../../assets/imgs/logo.png"/>
            </div>
            <el-menu
                    background-color="#424f63"
                    text-color="#fff"
                    active-text-color="$fontColor3"
                    class="menu-wrapper"
                    router
                    unique-opened
                    :collapse="isCollapsed"
                    :default-active="activeIndex">
                <template v-for="(item, index) in sider_menu_data">
                    <el-menu-item class="menu-item" v-if="!item.children" :index="item.path" :key="index">
                        <i :class="item.icon"></i>
                        <span slot="title">{{item.title}}</span>
                    </el-menu-item>
                    <el-submenu v-else :index="item.path">
                        <template slot="title">
                            <i :class="item.icon"></i>
                            <span slot="title">{{item.title}}</span>
                        </template>
                        <el-menu-item class="menu-item" v-for="(sub_item, sub_index) in item.children"
                                      :index="sub_item.path"
                                      :key="sub_index">
                            <span slot="title" style="margin-left:12px;">{{sub_item.title}}</span>
                        </el-menu-item>
                    </el-submenu>
                </template>
            </el-menu>
        </div>
        <div class="topbar-wrapper" :style="{left: this.isCollapsed?'64px':'200px'}">
            <div class="menu-collapse-wrapper float-left" @click="toggleMenu">
                <i class="el-icon-adm-menu"
                   :style="{transform: 'rotateZ(' + (this.isCollapsed ? '90' : '0') + 'deg)'}"></i>
            </div>
            <div class="title float-left">赛橙表 超管系统</div>
            <ul class="menu-list float-right">
                <li v-if="user" class="menu-item" style="padding: 0;">
                    <el-dropdown
                            :show-timeout="10"
                            :hide-timeout="10"
                            @command="handleCommand"
                            style="padding: 0 15px;">
                        <div class="dropdown-content el-dropdown-link">
                            <i class="icon el-icon-adm-usersetup"></i>
                            <span class="text">{{user.name || user.username}}</span>
                        </div>
                        <el-dropdown-menu slot="dropdown">
                            <!--<el-dropdown-item command="a">{{user.username}}</el-dropdown-item>-->
                            <!--<el-dropdown-item command="b">{{user.name}}</el-dropdown-item>-->
                            <!--<el-dropdown-item command="c">{{user.type.name}}</el-dropdown-item>-->
                            <el-dropdown-item command="changePwd">修改密码</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </li>
                <!--<li class="menu-item">-->
                <!--<i class="icon el-icon-adm-help"></i>-->
                <!--</li>-->
                <li class="menu-item" @click="exit">
                    <i class="icon iconfont el-icon-adm-exit"></i>
                </li>
            </ul>
        </div>
        <div class="content-wrapper" ref="content-wrapper" :style="{left: this.isCollapsed?'64px':'200px'}">
            <div class="content">
                <router-view></router-view>
            </div>
        </div>
        <el-dialog title="修改密码" :visible.sync="dialogFormVisible">
            <el-form
                    ref="changePwdForm"
                    :model="form"
                    :rules="rules">
                <el-form-item prop="oldPwd" label="原始密码" :label-width="formLabelWidth">
                    <el-input type="password" v-model="form.oldPwd" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item prop="newPwd" label="新密码" :label-width="formLabelWidth">
                    <el-input type="password" v-model="form.newPwd" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item prop="confirmOld" label="确认密码" :label-width="formLabelWidth">
                    <el-input type="password" v-model="form.confirmOld" autocomplete="off"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="changePwd('changePwdForm')">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
    import {sessionStorage} from 'src/assets/js/storage';
    import api from '../../api/api';
    // import {isIntegerNotMust} from '../../validator/validator';

    export default {
        created() {
            this.checkAuth();
        },

        // beforeCreate(){
        //     alert(1)
        //     this.user = this.$store.state.user;
        // },
        //
        //
        // beforeMount(){
        //     this.user = this.$store.state.user;
        //     alert(2)
        // },
        mounted(){
            this.user = this.$store.state.user || sessionStorage.getItem('user');
            // if(this.user.type.name === '5'){
            //     this.sider_menu_data=[
            //         {
            //             path: '/match/index',
            //             title: '赛事管理',
            //             icon: 'el-icon-adm-project'
            //         },
            //     ];
            // }
        },

        data() {
            return {
                dialogFormVisible: false,
                formLabelWidth: '120px',

                user:{},
                form: {
                    oldPwd: '',
                    newPwd: '',
                    confirmOld: ''
                },

                rules: {
                    // test: [{required: true, message: '旧密码不能为空', trigger: 'blur'}, {
                    //     validator: isIntegerNotMust,
                    //     trigger: 'blur'
                    // }],
                    oldPwd: [
                        {required: true, message: '旧密码不能为空', trigger: 'blur'}
                    ],
                    newPwd: [
                        {required: true, message: '新密码不能为空', trigger: 'blur'}
                    ],
                    confirmOld: [
                        {required: true, message: '确认密码不能为空', trigger: 'blur'}
                    ]
                },

                sider_menu_data: [
                    // {
                    //     path: '/home',
                    //     title: '首页',
                    //     icon: 'el-icon-adm-home'
                    // },
                    // {
                    //     path: '/tables',
                    //     title: '表格管理',
                    //     icon: 'el-icon-adm-linechart',
                    //     children: [
                    //         {path: '/tables/basic', title: '基本表格'},
                    //         {path: '/tables/sort', title: '排序表格'},
                    //         {path: '/tables/filter', title: '筛选表格'}
                    //     ]
                    // },
                    // {
                    //     path: '/charts',
                    //     title: '图表管理',
                    //     icon: 'el-icon-adm-statistics',
                    //     children: [
                    //         {path: '/charts/bar', title: '柱状图'},
                    //         {path: '/charts/line', title: '折线图'},
                    //         {path: '/charts/pie', title: '饼图'}
                    //     ]
                    // },
                    // {
                    //     path: '/form',
                    //     title: '表单管理',
                    //     icon: 'el-icon-adm-form',
                    //     children: [
                    //         {path: '/form/render', title: '渲染表单'}
                    //     ]
                    // },
                    // {
                    //     path: '/test/index',
                    //     title: '测试',
                    //     icon: 'el-icon-adm-formsetup'
                    // },


                    // {
                    //     path: '/match/index',
                    //     title: '赛事管理',
                    //     icon: 'el-icon-adm-project'
                    // },
                    // {
                    //     path: '/statistics/index',
                    //     title: '数据统计',
                    //     icon: 'el-icon-adm-organization'
                    // },
                    // {
                    //     path: '/account/index',
                    //     title: '帐号管理',
                    //     icon: 'el-icon-adm-user'
                    // },
                    // {
                    //     path: '/team/index',
                    //     title: '队伍管理',
                    //     icon: 'el-icon-adm-log'
                    // },
                    // {
                    //     path: '/overview/index',
                    //     title: '概览',
                    //     icon: 'el-icon-adm-home'
                    // },
                    // {
                    //     path: '/school/index',
                    //     title: '学校管理',
                    //     icon: 'el-icon-adm-organization'
                    // },
                    // {
                    //     path: '/student/index',
                    //     title: '学生管理',
                    //     icon: 'el-icon-adm-user'
                    // },
                    {
                        path: '/match/index',
                        title: '赛事管理',
                        icon: 'el-icon-adm-project'
                    },
                    // {
                    //     path: '/account/index',
                    //     title: '账号管理',
                    //     icon: 'el-icon-adm-formsetup'
                    // },
                    // {
                    //     path: '/apply/index',
                    //     title: '开户申请',
                    //     icon: 'el-icon-adm-log'
                    // },

                ],
                isCollapsed: false,
                adminMenuShow: false
            }
        },
        computed: {
            // user() {
            //     return this.$store.state.user;
            // },

            activeIndex() {
                // console.log(this.$route.path);
                // return this.$route.path;
                // return '/home'
                // if (this.$route.path === '/match/group_enroll'||this.$route.path === '/match/organization_enroll'||this.$route.path === '/match/manage'||this.$route.path === '/match/create_match'||this.$route.path === '/match/edit_match'||this.$route.path === '/match/edit_race'||this.$route.path === '/match/create_race') {
                //     return '/match/index'
                // } else if(this.$route.path === '/statistics/detail'){
                //     return '/statistics/index'
                // }else {
                //     return this.$route.path
                // }


                if(this.$route.path.indexOf('account') > 0){
                    return '/account/index'
                }else if(this.$route.path.indexOf('student') > 0){
                    return '/student/index'
                }else if(this.$route.path.indexOf('school') > 0){
                    return '/school/index'
                }else if(this.$route.path.indexOf('match') > 0){
                    return '/match/index'
                }else {
                    return this.$route.path;
                }

            }
        },
        methods: {
            // 检查登录状态
            checkAuth() {
                return
                let token = this.$store.state.token || sessionStorage.getItem('token');
                if (!token) {
                    this.$router.replace('/login');
                } else {
                    // this.getUser();
                }
            },
            // getUser() {
            //     let User = {
            //         id: '7f859967-9b12-441c-badc-8a7d312f6da4',
            //         username: 'admin',
            //         name: 'luichooy',
            //         type: {
            //             code: 0,
            //             name: '超级管理员'
            //         }
            //     };
            //
            //     console.log(this.$store.state.user)
            //     // this.$store.commit('SET_USER', User);
            // },
            handleCommand(command) {
                if (command === 'changePwd') {
                    this.dialogFormVisible = true;
                }
                console.log(command);
            },
            toggleMenu() {
                this.isCollapsed = !this.isCollapsed;
            },
            exit() {
                this.$confirm('即将退出系统登陆，是否继续？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                })
                    .then((e) => {
                        this._exitApp();

                    })
                    .catch(() => {
                        return false;
                    })
            },

            changePwd(formName) {
                if (this.form.newPwd !== this.form.confirmOld) {
                    this.$message({
                        message: '两次密码不统一',
                        type: 'warning'
                    });
                    return;
                }

                this.$refs[formName].validate(valid => {
                    if (valid) {
                        this._changePwd();
                    }
                });

            },

            //---------------http--------------
            _exitApp() {
                this.$router.replace({path: '/login'});
                localStorage.clear();

                // this.axios.get(api.http.exit, {}).then((response) => {
                //     if (response.code === 200) {
                //         this.$store.commit('SET_TOKEN', '');
                //         this.$store.commit('SET_USER', null);
                //         this.$router.replace({path: '/login'});
                //     }
                // }).catch((error) => {
                //     console.log(error);
                // });
            },

            _changePwd() {

                let form = new FormData();
                form.append('oldPwd', this.form.oldPwd);
                form.append('newPwd', this.form.newPwd);
                let param = new URLSearchParams(form);

                this.axios.post(api.http.changePwd, param).then((response) => {
                    if (response.code === 200) {
                        this.$message({
                            message: '修改密码成功',
                            type: 'success'
                        });
                        this.dialogFormVisible = false;
                        setTimeout(() => {
                            this._exitApp();
                        }, 2000)

                    } else {
                        this.$message.error(response.data);
                    }
                    console.log(response);
                }).catch((error) => {
                    console.log(error);
                });
            }
        }
    }
</script>
<style lang="scss">
    @import '../../assets/styles/variable';

    .siderbar-wrapper {
        position: fixed;
        top: 0;
        bottom: 0;
        left: 0;
        width: $siderbarWidth;
        z-index: 11;
        background-color: $siderbarBackgroundColor;
        transition: all 0.3s ease-in-out;

        .logo-wrapper {
            height: 40px;
            line-height: 40px;
            padding: 16px 0;
            text-align: center;
            font-size: 24px;
            color: $fontColor3;
            span {
                position: relative;
                top: -10px;
            }
        }

        .menu-wrapper {
            position: absolute;
            top: 72px;
            bottom: 0;
            width: 100%;
            border-right: none;
            transition: all 0.3s ease-in-out;

            &:not(.el-menu--collapse) {
                overflow-y: auto;
                overflow-x: hidden;
            }

            i {
                color: #FFFFFF;
            }

            .menu-item {

                &.is-active, &:hover {
                    background-color: #353F4F !important;
                    color: $fontColor3 !important;

                    i {
                        color: $fontColor3 !important;
                    }
                }
            }

            .el-submenu__title:hover {
                color: $fontColor3 !important;

                i {
                    color: $fontColor3 !important;
                }
            }

            .el-submenu, .el-menu-item {
                width: 100%;
            }
        }
    }

    .topbar-wrapper {
        position: fixed;
        left: $siderbarWidth;
        right: 0;
        top: 0;
        heihgt: $topbarHeight;
        line-height: $topbarHeight;
        padding: 0 24px 0 0;
        background-color: $topbarBackgroundColor;
        box-shadow: 0 2px 4px 0 rgba(0, 0, 0, .12), 0 0 6px 0 rgba(0, 0, 0, .04);
        transition: all 0.3s ease-in-out;
        z-index: 12;

        .menu-collapse-wrapper {
            height: 100%;
            width: 48px;
            text-align: center;
            cursor: pointer;

            i {
                transition: all 0.3s ease-in-out;
            }
        }

        .title {
            height: 100%;
            font-weight: bold;
        }

        .menu-list {
            .menu-item {
                position: relative;
                float: left;
                padding: 0 15px;
                min-width: 45px;
                height: 48px;
                text-align: center;
                font-size: 0px;

                &:hover {
                    cursor: pointer;
                    background-color: #F5F5F5;
                }

                .icon {
                    vertical-align: middle;
                    font-size: 24px;
                }

                .text {
                    display: inline-block;
                    vertical-align: middle;
                    margin-left: 4px;
                    font-size: 16px;
                }
            }
        }
    }

    .content-wrapper {
        position: fixed;
        left: $siderbarWidth;
        right: 0;
        top: $topbarHeight;
        bottom: 0;
        padding: 16px;
        overflow: auto;
        transition: all 0.3s ease-in-out;

        .content {
            position: relative;
            width: 100%;
            height: 100%;
        }
    }

    .layout {
        img {
            height: 100%;
        }
    }
</style>



// WEBPACK FOOTER //
// src/pages/layout/layout.vue